import React, { Component } from 'react';
import DialogTimeout from './token/DialogTimeout';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import * as storage from '../utils/storage';
import TermsUse from './helpOnline/TermsUse';
import HelpOnline from './helpOnline/HelpOnline';
import { ValidateToken } from '../utils/token';
import HelpOnlineButton from './helpOnline/HelpOnlineButton';
import * as SourcePage from '../scripts/HelpOnlineSourcePage';
import Logout from './login/Logout';
import LoadingLayer from './controls/LoadingLayer';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';

class Layout extends Component {
    static displayName = Layout.name;

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    constructor(props) {
        super(props)

        let showTerms = false;

        if (storage.getTermsUse() !== undefined && storage.getTermsUse() !== null && storage.getTermsUse().length <= 0) {
            showTerms = false;
        } else {
            showTerms = !storage.getAcceptedTermsUse();
        }

        this.state = {
            openHelp: false,
            infoLegal: false,
            typeHelp: null,
            typeInfo: null,
            showTerms: showTerms,
            isProcessing: false
        };
    }

    componentDidMount() {
        ValidateToken(this.props);
    }

    handleHelpOnline = (typeHelp) => {
        this.setState({ openHelp: true, typeHelp: typeHelp });
    }

    handleCloseHelpOnline = () => {
        this.setState({ openHelp: false });
    }

    handleStatusLogout = (status) => {
        this.setState({ isProcessing: status });
    }

    render() {
        return (
            <div id="App">
                <LoadingLayer isActive={this.state.isProcessing} message={i18next.t('logout:message.logout')}>
                    <Logout handleStatus={this.handleStatusLogout} />
                    <div style={{ position: 'absolute', right: '15px', top: '10px', color: '#ffffff', fontSize: 22, zIndex: 999 }} >
                        <HelpOnlineButton SourcePage={SourcePage.Source_Home} />
                    </div>
                    <DialogTimeout {...this.props} />
                    <div id="page-wrap">
                        {!this.state.showTerms && this.props.children}
                    </div>
                    <div>
                        {this.state.showTerms && <TermsUse />}
                    </div>
                    <HelpOnline open={this.state.openHelp} handleClose={this.handleCloseHelpOnline} typeHelp={this.state.typeHelp} />
                </LoadingLayer>
            </div>
        );
    }
}

export default withNamespaces(['logout'], { wait: true })(withCookies(Layout));